import React, { useEffect, useState } from "react";
import "./HomePage.css";
import EventCarousel from "./components/EventCarousel";
import HeroSection from "./components/HeroSection";
import TrendingSection from "./components/TrendingSection";
import Reveal from "../../common_components/Reveal";

// Firestore imports removed
import { Link } from "react-router-dom";
import { ApiService } from "../../services/api_service";
import { filterEventsByDistance } from "../../utils/geolocation";
import useUserLocation from "../../hooks/useUserLocation";

const AllEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const userLocation = useUserLocation();
  const selectedCity = userLocation?.city || "";

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await ApiService.getAllEvents();
        // Handle response. data usually contains the list or map.
        // Assuming response is array or response.data is array/map
        let fetchedEvents = response.data || response;

        // If fetchedEvents is an object/map, convert to array
        if (fetchedEvents && !Array.isArray(fetchedEvents) && typeof fetchedEvents === 'object') {
          fetchedEvents = Object.values(fetchedEvents);
        }

        if (!Array.isArray(fetchedEvents)) {
          console.error("Unexpected events data format", fetchedEvents);
          fetchedEvents = [];
        }

        // 1. Featured Events - events where isFeatured == true
        const featuredEvents = fetchedEvents.filter(event => event.isFeatured === true);

        // 2. Happening Near You - events within 50km of the stored location
        // (exact GPS coords if the user auto-detected, city coords if manual)
        const nearbyEvents = userLocation
          ? filterEventsByDistance(
              fetchedEvents,
              { lat: userLocation.latitude, lon: userLocation.longitude },
              50
            )
          : [];

        // 3. Trending Events - no specific logic, just show any events
        const trendingEvents = fetchedEvents.filter(event => !event.isFeatured);

        // 4. Popular Events - no specific logic, show any events
        const popularEvents = fetchedEvents;

        // Store all categorized events
        setEvents({
          featured: featuredEvents,
          nearby: nearbyEvents,
          trending: trendingEvents,
          popular: popularEvents,
          all: fetchedEvents
        });
      } catch (error) {
        console.error("Error fetching events:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, [userLocation]);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#111111] pb-20 px-4 sm:px-6 lg:px-[120px]">
        {/* Hero skeleton */}
        <div className="pt-[134px] max-w-[1200px] mx-auto">
          <div className="skeleton h-[340px] sm:h-[380px] lg:h-[420px] rounded-[20px]" />
        </div>

        {/* Carousel skeleton */}
        <div className="mt-16">
          <div className="skeleton h-6 w-48 mb-8 rounded-md" />
          <div className="flex gap-3 sm:gap-4 md:gap-6 overflow-hidden">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="flex-shrink-0 w-[180px] sm:w-[200px] md:w-[220px]">
                <div className="skeleton h-[200px] sm:h-[240px] md:h-[280px] rounded-xl mb-3" />
                <div className="skeleton h-4 w-3/4 rounded-md mb-2" />
                <div className="skeleton h-3 w-1/2 rounded-md" />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }


  // Data for Sections - using categorized events
  const heroEvents = events.featured?.slice(0, 5) || [];
  const happeningNearMeEvents = events.nearby?.slice(0, 10) || [];
  const trendingFeatured = events.trending?.[0] || events.all?.[0];
  const trendingList = events.trending?.slice(1, 4) || [];
  const popularEvents = events.popular?.slice(0, 10) || [];

  return (
    <div className="min-h-screen bg-[#111111] text-white pb-20">

      {/* 1. Hero Section - Featured Events */}
      <div className="pt-[134px] px-4 sm:px-6 lg:px-[120px] mb-[60px]">
        <Reveal>
          <HeroSection events={heroEvents} />
        </Reveal>
      </div>

      {/* 2. Popular Events - Any events */}
      <div className="px-4 sm:px-6 lg:px-[120px] mb-12">
        <EventCarousel
          events={popularEvents}
          title="Popular Events"
        />
      </div>

      {/* 3. Trending Section - Any events */}
      <Reveal>
        <TrendingSection
          featuredEvent={trendingFeatured}
          trendingEvents={trendingList}
          city={selectedCity}
        />
      </Reveal>

      {/* 4. Happening Near Me Carousel - Events within 50km (hidden when empty) */}
      {happeningNearMeEvents.length > 0 && (
        <div className="px-4 sm:px-6 lg:px-[120px] mt-12 mb-12">
          <EventCarousel
            events={happeningNearMeEvents}
            title="Happening Near Me"
          />
        </div>
      )}



    </div>
  );
};

export default AllEvents;

